export function identity<T>(x: T): T {
  return x;
}



// WEBPACK FOOTER //
// ../../src/util/identity.ts